import { useHarnessStore } from '@/store/useHarnessStore';
import { MeasurementPlotView } from './MeasurementPlotView';

/**
 * Live-harness plot: binds {@link MeasurementPlotView} to the store's Measurements and selection.
 * The review view (Story 3.1) reuses `MeasurementPlotView` directly with fetched data.
 */
export function MeasurementPlot() {
  const measurements = useHarnessStore((s) => s.measurements);
  const selectedMeasurementIds = useHarnessStore((s) => s.selectedMeasurementIds);

  return <MeasurementPlotView measurements={measurements} selectedIds={selectedMeasurementIds} />;
}
